<h1 class="page-title">
  Locuri de parcare
</h1>

<div class="container">
  <div
    fxLayout.gt-xs="row"
    fxLayout="column"
    fxLayoutGap="20px"
  >
    <div
      fxLayout="column"
      fxLayoutAlign="start center"
      class="lifestyle-item"
    >
      <img src="/assets/images/parking/supraterana.webp" alt="Parcare supraterană" class="image" loading="lazy">
      <h3 class="title">
        Parcare supraterană
      </h3>
      <p>
        Nu îți vei mai pune niciodată problema dacă ai unde
        să parchezi sau nu. Conceptul Dream Residence pune
        la dispoziție parcare supraterană. Ba mai mult, spațiile comune
        beneficiază de supraveghere video pentru siguranța ta și a familiei tale
      </p>
      <label class="subtitle">
        6000 EUR (TVA 19% inclus)
      </label>
    </div>
    <div
      fxLayout="column"
      fxLayoutAlign="start center"
      class="lifestyle-item"
    >
      <img src="/assets/images/parking/subterana.webp" alt="Parcare subterană" class="image" loading="lazy">
      <h3 class="title">
        Parcare subterană
      </h3>
      <p>
        Preferi parcarea subterană? Conceptul Dream Residennce pune la dispoziția ta parcare subterană,
        cu lifturi de acces și de asemenea cu supraveghere video.
        Parcările subterane îți asigură un maxim de confort ție și familie tale indiferent de anotimp.
      </p>
      <label class="subtitle">
        12000 EUR (TVA 19% inclus)
      </label>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/parking/parking.component.html